import React, { Component } from 'react';
import {getPress,getPressFinal} from '../components/Factory' 
import Presse from '../components/Presse'; 
import PresseAustellungen from '../components/PresseAustellungen'; 
import PresseNeuigkeiten from '../components/PresseNeuigkeiten'; 
import PresseDiekunsthalle from '../components/PresseDiekunsthalle'; 
import VisibilitySensor from 'react-visibility-sensor';
import Flexbox from '../components/misc/Flexbox'; 
import {createMarkup} from '../components/Factory'

class PresseReleaseContainer extends Component {
	constructor(props) {
		super(props);
		this.state = { 
		  presse: [],
		  offset : 0,
		  finished:'block',
		  login:this.props.resolves.login,
		  pass:'',
		  message:'',
		  pagetype:this.props.resolves.pagetype,
		  finaldata:''
		}
		this.onChange = this.onChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}
	onChange(isVisible){
		if(isVisible && this.state.offset>0) { 
			this.loadMore();
		}
	}	
	loadFinal(type){
		fetch(getPressFinal(this.props.resolves.slug,type,this.props.resolves.page.id),
			{
				method:'post',
				headers: {'Content-Type':'application/x-www-form-urlencoded'},
				body:'password='+this.state.pass
			}
			)
			.then(res => res.json())
		    .then(res => {
				this.setState({
					finaldata:res
				})
			})
	}
	loadMore(){		
		fetch(getPress({ 
						number:10,
						offset:this.state.offset,
						id:this.props.resolves.page.id
						}),
						{
							method:'post',
							headers: {'Content-Type':'application/x-www-form-urlencoded'},
							body:'password='+this.state.pass+'&post_type='+this.state.pagetype
						}
						)
					  .then(res => res.json())
					  .then(res => {
							if(res.length>0){
								let Message = '';								
								if(this.state.login){
									if(res[0].password_check){
										localStorage.setItem('password',this.state.pass);
										const {stateService} = this.props.transition.router;										
										this.props.handlePrivateClass();
										stateService.go("root.presse.ausstellungen");
									}
									else{
										this.setState({
											message:"Wrong Password"
										})
									}	
								}
								else{
									this.setState({
										presse: [...this.state.presse,...res],
										offset: this.state.offset+10,
										login:false,
										message:Message
									});
								}	
							}
							else
								this.setState({
									finished:'none'
								});
					  })
	}
	componentWillMount(){
		document.body.scrollTop = document.documentElement.scrollTop = 0;
		if(localStorage.getItem('password')!=="" && this.state.pagetype==='ausstellungen'){			
			this.setState({
				pass:localStorage.getItem('password')
			});
			let dis = this;
			setTimeout(function(){
				dis.loadMore();
				dis.props.handlePrivateClass();
			},0);
		}
		if(localStorage.getItem('password')!=="" && this.state.pagetype==='neuigkeiten'){
			this.setState({
				pass:localStorage.getItem('password')
			});
			let dis = this;
			setTimeout(function(){
				dis.loadMore();
				dis.props.handlePrivateClass();
			},0);
		}
		if(localStorage.getItem('password')!=="" && this.state.pagetype==='ausstellungen.details'){
			
			this.setState({
				pass:localStorage.getItem('password')
			});
			let dis = this;
			setTimeout(function(){
				dis.loadFinal('ausstellungen');
				dis.props.handlePrivateClass();
			},0);
		}
		if(localStorage.getItem('password')!=="" && this.state.pagetype==='neuigkeiten.details'){
			
			this.setState({
				pass:localStorage.getItem('password')
			});
			let dis = this;
			setTimeout(function(){
				dis.loadFinal('aktuelles');
				dis.props.handlePrivateClass();
			},0);
		}
		if(localStorage.getItem('password')!=="" && this.state.pagetype==='die-kunsthalle'){
			
			this.setState({
				pass:localStorage.getItem('password')
			});
			let dis = this;
			setTimeout(function(){
				dis.loadFinal('page');
				dis.props.handlePrivateClass();
			},0);
		}
	}
	handleSubmit(e){
		e.preventDefault();
		this.setState({
			presse:[],
			offset:0,
			pass:this.password.value,
			message:'...'
		});
		let dis = this;
		setTimeout(function(){
			dis.loadMore();			
		},100);
		
	}
	componentDidMount(){	 
		let dis = this;
		setTimeout(function(){
			let submenu = document.getElementById('submenu-'+dis.state.pagetype);
			if(submenu)
				submenu.classList.add('active');
			document.getElementById('menu-presse').classList.add('active');
		},400);
	}
	componentWillUnmount(){
		let submenu = document.getElementById('submenu-'+this.state.pagetype);
		if(submenu)
			submenu.classList.remove('active');
		document.getElementById('menu-presse').classList.remove('active');	
	}
	render() {		   
		   const {title_left,title_right,page_content} = this.props.resolves.page;
		   const { label_password,label_anmelden,label_pressmappe } = this.props.resolves.staticData;
		   return ( 
				<div className="container-fluid lg-side-padding ">
					<div className="row">           
						
							{
								(this.state.login)?
                                <div className="col-md-12 content-container">
                                    <div>
                                        <Flexbox left={title_left} right={title_right} />
                                        <p className="md-txt" dangerouslySetInnerHTML={createMarkup(page_content)}></p>
                                        <form id="press_login_form" className="margin-top-50 password-form" onSubmit={this.handleSubmit} >
                                            <label>{label_password}</label>
                                            <input type="password" defaultValue={localStorage.getItem('password')} ref={(input) => { this.password = input; }} />
                                            <input type="submit" value={label_anmelden} className="submit-pass-btn btn dark-btn"/>
                                            <label>{this.state.message}</label>
                                        </form>

                                    </div>				
								</div>				
								:
									(this.state.pagetype==='ausstellungen' || this.state.pagetype==='neuigkeiten')?
										<div className="col-md-12">
											<section className="press-list">
												{
													this.state.presse.map( (data,i)=>{
														return <Presse pagetype={this.state.pagetype}  key={i} {...data} />
													})
												}
											</section>
											{
											(this.state.offset>0)?
											<VisibilitySensor onChange={this.onChange}>
												<div className="loading small" style={{display:this.state.finished}}>
													<div className="one"></div>			
												</div>
											</VisibilitySensor>
											:null
											}
										</div>
									: 	
									(this.state.pagetype==='ausstellungen.details')?
										<PresseAustellungen label_pressmappe={label_pressmappe} {...this.state.finaldata}  />
									:
									(this.state.pagetype==='die-kunsthalle')?
										<PresseDiekunsthalle label_pressmappe={label_pressmappe} {...this.state.finaldata}  />
									:
									(this.state.pagetype==='neuigkeiten.details')?
										<PresseNeuigkeiten label_pressmappe={label_pressmappe} {...this.state.finaldata}  />
									:null
								
							}
					</div>
				</div>
			)
	   
	}
}
export default PresseReleaseContainer;


// WEBPACK FOOTER //
// ./src/containers/PresseReleaseContainer.js